module.exports = __webpack_public_path__ + "img/gold-arrow.9c013a7e.svg";